import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Global } from '@services/core/Global';
import { Observable } from 'rxjs';
import { HomeModel } from './home.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private http = inject(HttpClient);
  private url = Global.url + 'V1/dashboard/';

  getPeriods(filters: any = {}): Observable<any[]> {
    return this.http.get<any[]>(this.url + 'periods', { params: filters });
  }

  getKpis(filters: HomeModel): Observable<any> {
    return this.http.get<any>(this.url + 'kpis', { params: this.toParams(filters) });
  }

  getCharts(filters: HomeModel): Observable<any> {
    return this.http.get<any>(this.url + 'charts', { params: this.toParams(filters) });
  }

  getActivity(filters: HomeModel): Observable<any> {
    return this.http.get<any>(this.url + 'activity', { params: this.toParams(filters) });
  }

  getRanking(filters: HomeModel): Observable<any> {
    return this.http.get<any>(this.url + 'ranking', { params: this.toParams(filters) });
  }

  getSummary(filters: HomeModel): Observable<any> {
    return this.http.get<any>(this.url + 'summary', { params: this.toParams(filters) });
  }

  getFdr(filters: HomeModel): Observable<any[]> {
    return this.http.get<any[]>(this.url + 'fdr', { params: this.toParams(filters) });
  }

  getAccount(filters: any = {}): Observable<any[]> {
    return this.http.get<any[]>(this.url + 'accounts', { params: filters });
  }

  totalAccountMovements(filters: any = {}): Observable<any[]> {
    return this.http.get<any[]>(this.url + 'movements-total', { params: filters });
  }

  getContributionsByEntity(): Observable<any[]> {
    return this.http.get<any[]>(this.url + 'contributions-entities');
  }

  getGenerateCollections(periodId: number): Observable<any[]> {
    return this.http.get<any[]>(this.url + 'generate-collections', { params: { periodId } });
  }

  closePeriod(id: number): Observable<any> {
    return this.http.post<any>(this.url + 'close-period', { id });
  }

  sendMail(mailOptions: any): Observable<any> {
    return this.http.post<any>(this.url + 'send-mail', mailOptions);
  }

  private toParams(filters: HomeModel): Record<string, string | number> {
    const params: Record<string, string | number> = {};
    const start = this.toId(filters?.periodIdStart);
    const end = this.toId(filters?.periodIdEnd);
    if (start != null) params.periodIdStart = start;
    if (end != null) params.periodIdEnd = end;
    if (filters?.campusId != null) params.campusId = filters.campusId;
    if (filters?.entityCode) params.entityCode = filters.entityCode;
    if (filters?.type != null) params.type = filters.type;
    return params;
  }

  private toId(value: unknown): number | null {
    if (value == null || value === '' || value === 'null' || value === 'undefined') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
}
